import styled from 'styled-components';

export const Container = styled.div`
  padding-top: ${({ theme }) => theme.spacing(2.5)};
  padding-bottom: ${({ theme }) => theme.spacing(2.5)};
`;
